import DisplayListSvg from '@/assets/DisplayListSvg.svg';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FC } from 'react';
import { ListGroup } from 'react-bootstrap';

interface Props {
  answer: string;
  id: string;
}

export const SortableItem: FC<Props> = ({ answer, id }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
  const isMobile = useMobileMediaQuery();

  const style = {
    touchAction: isMobile ? 'manipulation ' : 'none',
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <ListGroup.Item
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="list-item gap-s"
    >
      <img alt="display-list" src={DisplayListSvg} />
      <p className="lead ml-3"> {answer}</p>
    </ListGroup.Item>
  );
};
